import { Button, Grid2, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import styles from './styles';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import {
  AlternateEmail,
  LockOutlined,
  RemoveRedEye,
  VisibilityOff,
} from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { recoveredData } from 'js/actions/userActions';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles(styles);

export default function RecoveredEmail() {
  const classes = useStyles();
  const { handleSubmit, register } = useForm();
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const { token } = useParams();
  const rootClassName = classNames(classes.root);

  function onSubmit(email) {
    dispatch(recoveredData(email, token));
  }

  return (
    <div className={rootClassName}>
      <Grid2 className={classes.grid} container={true}>
        <Grid2 className={classes.content} size={{ lg: 12, xs: 12 }}>
          <div className={classes.contentWrapper}>
            <div className={classes.formBox}>
              <div className={classes.contentBody}>
                <form
                  className={classes.form}
                  onSubmit={handleSubmit(onSubmit)}
                >
                  <div className={classes.divImage}>
                    <img
                      alt="Metimur Logo"
                      src="/images/logo-metimur.png"
                      width="140px"
                    />
                  </div>
                  <div className={classes.fields}>
                    <TextField
                      className={classes.textField}
                      type="email"
                      placeholder="Correo Electrónico"
                      variant="outlined"
                      size="medium"
                      slotProps={{
                        input: {
                          startAdornment: <AlternateEmail />,
                        },
                      }}
                      {...register('email', { required: true })}
                    />
                    <TextField
                      className={classes.textField}
                      placeholder="Contraseña"
                      variant="outlined"
                      size="medium"
                      type={showPassword === true ? 'text' : 'password'}
                      slotProps={{
                        input: {
                          startAdornment: <LockOutlined />,
                          endAdornment: (
                            <div>
                              {showPassword === true ? (
                                <RemoveRedEye
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              ) : (
                                <VisibilityOff
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              )}
                            </div>
                          ),
                        },
                      }}
                      {...register('password', { required: true })}
                    />
                    <TextField
                      className={classes.textField}
                      placeholder="Confirmar Nueva Contraseña"
                      variant="outlined"
                      size="medium"
                      type={showPassword === true ? 'text' : 'password'}
                      slotProps={{
                        input: {
                          startAdornment: <LockOutlined />,
                          endAdornment: (
                            <div>
                              {showPassword === true ? (
                                <RemoveRedEye
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              ) : (
                                <VisibilityOff
                                  sx={{ cursor: 'pointer' }}
                                  onClick={() => setShowPassword(!showPassword)}
                                />
                              )}
                            </div>
                          ),
                        },
                      }}
                      {...register('password_confirmation', { required: true })}
                    />
                  </div>
                  <Button
                    className={classes.signInButton}
                    color="secondary"
                    size="large"
                    type="submit"
                    variant="contained"
                  >
                    Recuperar Contraseña
                  </Button>
                </form>
              </div>
            </div>
          </div>
        </Grid2>
      </Grid2>
    </div>
  );
}
